var _defs, _path, _circle, _line, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleSwitchedWallSocket01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.cls-1 {\n\t\t\tfill: none;\n\t\t\tstroke: #FFFFFF;\n\t\t\tstroke-miterlimit: 10;\n\t\t\tstroke-width: 0.15px;\n\t\t\t}\n\n\t\t\t.cls-2 {\n\t\t\tfont-size: 3px;\n\t\t\tfont-family: MyriadPro-Regular, Myriad Pro;\n\t\t\tfill: #FFFFFF;\n\t\t\t}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Double Switched Wall Socket") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.93,2.29A5.88,5.88,0,0,1,8.51,8.35a6.08,6.08,0,0,1-5.58,5.36"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 9.03,
    cy: 8,
    r: 0.51
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.55,
    y1: 8,
    x2: 13.07,
    y2: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(10.29 8.74)"
  }, "2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleSwitchedWallSocket01);
export default __webpack_public_path__ + "static/media/DoubleSwitchedWallSocket-01.4ed35ebb0ead8793eedfa0ca94483ec9.svg";
export { ForwardRef as ReactComponent };